import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from '../Reveal';
interface BookingStepProps {
  number: number;
  title: string;
  hint?: string;
  error?: string;
  children: React.ReactNode;
}
export function BookingStep({
  number,
  title,
  hint,
  error,
  children
}: BookingStepProps) {
  return <Reveal as="section" data-id="element-68" data-mp="3rkhih6vu4g5m">
      <div className="mb-6 flex items-center gap-4 border-b border-forest-700/10 pb-4" data-id="element-69" data-mp="cwlar3j8haa">
        <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest-700 font-display text-sm text-gold-300" data-id="element-70" data-mp="4dovbmk8aq7m">
          {number}
        </span>
        <div data-id="element-71" data-mp="9b8khhigsnec">
          <h2 className="font-display text-xl text-forest-700" data-id="element-72" data-mp="ebw8rvfb6q4v">{title}</h2>
          {hint && <p className="mt-0.5 text-[13px] text-muted" data-id="element-73" data-mp="e9s61gt5bx66">{hint}</p>}
        </div>
      </div>
      <AnimatePresence data-id="element-74" data-mp="2b6izk2p18ci5">
        {error && <motion.p initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18
      }} className="mb-5 flex items-center gap-2 rounded-sm bg-danger-50 px-4 py-3 text-[13px] text-danger-700" role="alert" data-id="element-75" data-mp="2g2pul0fw43lb">
            <AlertCircleIcon size={15} aria-hidden="true" data-id="element-76" data-mp="bv0vmm0tt2i8" />
            {error}
          </motion.p>}
      </AnimatePresence>
      {children}
    </Reveal>;
}